var React = require('react');

function MarkerInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M34.2 90h.3c8.2-12 34.6-33.9 34.2-57.5C68.8 14.7 52.4.2 34.5 0h-.3C16.4.2 0 14.7 0 32.5-.4 56.1 26 78 34.2 90z"}));
}

MarkerInline.defaultProps = {"viewBox":"0 0 68.8 90","style":{"enableBackground":"new 0 0 68.8 90"},"xmlSpace":"preserve"};

module.exports = MarkerInline;

MarkerInline.default = MarkerInline;
